import { MessageCircle, ArrowLeft, ShieldX } from "lucide-react";

export default function SinCotizacionStep({ cot, moto, onBack }) {
  return (
    <div data-testid="step-sin-cotizacion" className="pt-6 text-center">
      <ShieldX className="w-14 h-14 text-slate-300 mx-auto mb-4" />
      <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">No tenemos cotización disponible para tu moto</h1>
      <p className="text-slate-500 mb-6" data-testid="sin-cot-mensaje">
        Por el valor o las caracteristicas de tu {moto.marca_desc} {moto.modelo_desc} {moto.anio}, no podemos ofrecerte una cotización online. Escribinos y lo vemos de forma personalizada.
      </p>
      {cot?.whatsapp_url && (
        <a data-testid="sin-cot-whatsapp-button" href={cot.whatsapp_url} target="_blank" rel="noopener noreferrer"
          className="w-full h-14 rounded-full bg-[#25D366] hover:bg-[#1eb856] text-white font-heading font-semibold text-lg flex items-center justify-center gap-2 transition mb-3">
          <MessageCircle className="w-5 h-5" /> Consultar por WhatsApp
        </a>
      )}
      <button data-testid="sin-cot-volver-button" onClick={onBack}
        className="w-full h-14 rounded-full border-2 border-slate-300 text-slate-700 font-heading font-semibold flex items-center justify-center gap-2 bg-white hover:bg-slate-50 transition">
        <ArrowLeft className="w-5 h-5" /> Cotizar otra moto
      </button>
    </div>
  );
}
